// extracted by mini-css-extract-plugin
export default {"red":"Contracts_red__xUkq6","strong":"Contracts_strong__s8MFj","table":"Contracts_table__dUn7R"};